export const inputStyle = {
  default: {
    borderColor: 'gray.400',
    helperColor: 'gray.400',
    icon: null,
  },
  error: {
    borderColor: 'system.error.default',
    helperColor: 'system.error.default',
    icon: 'times',
  },
  success: {
    borderColor: 'system.success.default',
    helperColor: 'system.success.default',
    icon: 'check',
  },
  disabled: {
    borderColor: 'gray.400',
    helperColor: 'gray.400',
    icon: null,
  },
};
